import React, { useRef, useEffect, useState } from 'react';
import useSound from 'use-sound';

import { Button, Image } from 'react-bootstrap';
import { BsFillXCircleFill, BsX } from 'react-icons/bs';

import { useNavigate } from 'react-router-dom';
import { useBadging } from '../hooks/badges';
import { useMessage } from '../hooks/message';
import { useAuth } from '../hooks/auth';
import { useToast } from '../hooks/toast';
import { useUserStatus } from '../hooks/userStatus';
import { useUserConfig } from '../hooks/userConfig';
import { useTabVisibility } from '../hooks/tabVisibility';

import { Message, Messages } from '../interfaces/IMessage';
import DataClientService from '../interfaces/IDataClientService';

import notificationSound from '../assets/sound/notification-mensage.mp3';
import notificationSoundNewClient from '../assets/sound/notification-new-client.wav';

import UserAcronym from './userAcronym';

import iconConversaCliente from '../assets/icon/conversaCliente.svg';
import iconConversaGrupo from '../assets/icon/conversaGrupo.svg';

import Users from '../interfaces/IUsers';
import { userStatus as userStatusEnum } from '../enums/userStatus';
import DataChatUser from '../interfaces/IDataChatUser';
import { isSameLocalDay } from '../utils/dateTime';

interface DataChatNotification {
  seqGrupoConversa: number;
  seqAtendimento: number;
}

const FooterMenu: React.FC<any> = () => {
  const {
    clientsAccepted,
    clientWaiting,
    loadClientsWaiting,
    loadClientsAccepted,
    getMensages,
    getMensagesGroup,
    loadDataClient,
    SetClientsAccepted,
    loadDataClienteRequestService,
    SetClientMessageService,
    chatUser,
    SetChatUser,
    getChatGroup,
    getChatGroupMsgPendente,
    updateMensageRead,
    updateMensageReadAtendimento,
    removeTagsHtml,
    alertNewClientIdTimeout,
    setAlertNewClientIdTimeout,
    messages,
  } = useMessage();

  const {
    loadAllUsersStatus,
    updateUserStatus,
    loadUserSubordinado,
    loadAllUser,
  } = useUserStatus();
  const isTabVisible = useTabVisibility();

  const [playSoundNotification] = useSound(notificationSound, {
    volume: 1,
  });
  const [playSoundNotificationNewClient] = useSound(
    notificationSoundNewClient,
    { volume: 1 }
  );

  const [playingSound, setPlayingSound] = useState<boolean>(false);

  const divButtonChatRef = useRef<HTMLDivElement[]>([]);
  const divButtonChatGroupRef = useRef<HTMLDivElement[]>([]);

  const { dataConnection, registerUserStatus, connectSignalR } = useAuth();
  const { hubConnection } = dataConnection;
  const [intervalID, setIntervalID] = useState({} as NodeJS.Timer);
  const [chatUserTmp, setChatUserTmp] = useState<DataChatUser[]>(
    [] as DataChatUser[]
  );
  const badge = useBadging();

  const bntNotification = useRef<HTMLButtonElement>(null);
  const bntNotificationNewClient = useRef<HTMLButtonElement>(null);
  const blnAbaAtiva = useRef<boolean>(false);

  const navigate = useNavigate();
  const { addToast } = useToast();
  const { loadDepartamentos } = useUserConfig();

  const buttonChat = (id: number): void => {
    divButtonChatRef.current[id].classList.remove('bt-flash');
    navigate(`/chat?id=${id}`);
    window.focus();
  };

  const buttonChatUser = (seqGrupoConversa: number): void => {
    divButtonChatGroupRef.current[seqGrupoConversa].classList.remove(
      'bt-flash'
    );
    navigate(`/chatUser?id=${seqGrupoConversa}`);
    window.focus();
  };

  const clickButtonMensage = (seqAtendimento: number): void => {
    const client = clientsAccepted.find(
      (clientFind) => clientFind.seqAtendimento === seqAtendimento
    );

    if (client !== undefined) {
      if (client.seqStatusAtendimento !== 2) {
        SetClientsAccepted(
          clientsAccepted.filter(
            (clientFind) => clientFind.seqAtendimento !== seqAtendimento
          )
        );

        navigate('/');
      } else {
        addToast({
          type: 'warning',
          title: 'Atenção',
          description: 'Não é possível fechar o chat em andamento.',
        });
      }
    }
  };

  const getParameterByName = (
    name: string,
    url = window.location.href
  ): string => {
    const nameParam = name.replace('/[[]]/g', '\\$&');
    const regex = new RegExp(`[?&]${nameParam}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return '';
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  const clickButtonMensageUsuario = (seqGrupoConversa: number): void => {
    SetChatUser(
      chatUser.filter((chat) => chat.seqGrupoConversa !== seqGrupoConversa)
    );

    const chatUserTemp = chatUserTmp.filter(
      (chat) => chat.seqGrupoConversa !== seqGrupoConversa
    );

    setChatUserTmp(chatUserTemp);
    localStorage.setItem('@LiveChat:chatUser', JSON.stringify(chatUserTemp));

    if (window.location.pathname === '/chatUser') {
      const seqConversa = getParameterByName('id');
      if (Number(seqConversa) > 0) updateMensageRead(Number(seqConversa));
    }

    navigate('/');
  };

  const showNewNotification = (
    title: string,
    body: string,
    data: DataChatNotification
  ): void => {
    // Se o chat está aberto na tela, não exibe a notificação
    if (document.hasFocus()) return;
    const notification = new Notification(title, {
      icon: 'LiveChatLogo192.png',
      body,
      data,
    });

    notification.addEventListener('click', (e) => {
      const dadosChat: DataChatNotification = notification.data;

      if (dadosChat.seqAtendimento > 0) {
        buttonChat(dadosChat.seqAtendimento);
      } else {
        buttonChatUser(dadosChat.seqGrupoConversa);
      }
    });
  };

  useEffect(() => {
    const statusUser = Number(localStorage.getItem('@LiveChat:userStatus'));

    if (clientWaiting.length > 0 && statusUser === userStatusEnum.Online) {
      if (!playingSound) {
        setPlayingSound(true);
        setAlertNewClientIdTimeout(
          setInterval(() => {
            bntNotificationNewClient.current?.click();
          }, 5000)
        );
      }
    } else {
      setPlayingSound(false);
      clearInterval(alertNewClientIdTimeout);
    }
  }, [clientWaiting]);

  const VerificaHistoricoChat = (): void => {
    const chatUserString = localStorage.getItem('@LiveChat:chatUser');

    if (chatUserString) {
      const chatUserTemp: DataChatUser[] = JSON.parse(chatUserString);

      const ChatUserTempDay = chatUserTemp.filter((item) => {
        if (!item.dataConversa) return false;
        return isSameLocalDay(item.dataConversa, new Date());
      });

      // Passo 1: Criar um Set com os seqGrupoConversa já existentes chatUserTemp
      const seqChatExistente = new Set(
        ChatUserTempDay.map((item) => item.seqGrupoConversa)
      );

      // Passo 2: Filtrar os itens do chatUser que não estão no Set
      const novosChats = chatUser.filter(
        (item) => !seqChatExistente.has(item.seqGrupoConversa)
      );

      // Passo 3: Adicionar os novos itens ao chatUserTmp (imutavelmente)
      const chatUserTmpAtualizado = [...ChatUserTempDay, ...novosChats];
      localStorage.setItem(
        '@LiveChat:chatUser',
        JSON.stringify(chatUserTmpAtualizado)
      );
      setChatUserTmp(chatUserTmpAtualizado);
    } else if (chatUser) {
      localStorage.setItem('@LiveChat:chatUser', JSON.stringify(chatUser));
      setChatUserTmp(chatUser);
    }
  };

  // Função para contar mensagens não lidas
  const getUnreadMessagesCount = (seqAtendimento: number): number => {
    const clientMessages = messages.find(
      (msg) => msg.seqAtendimento === seqAtendimento
    );

    if (!clientMessages || !clientMessages.messages) {
      return 0;
    }

    return clientMessages.messages.filter(
      (msg) => msg.mensagemLidaUsuario === 'N' && msg.seqUsuario === null
    ).length;
  };

  useEffect(() => {
    VerificaHistoricoChat();
  }, [chatUser]);

  useEffect(() => {
    loadClientsWaiting();
    loadClientsAccepted();
    loadDataClienteRequestService();
    loadAllUsersStatus();
    getChatGroupMsgPendente();
    loadDepartamentos();
    loadUserSubordinado();
    loadAllUser();
  }, []);

  useEffect(() => {
    blnAbaAtiva.current = isTabVisible;

    if (isTabVisible) {
      if (window.location.pathname === '/chatUser') {
        const seqConversa = getParameterByName('id');
        if (Number(seqConversa) > 0) {
          const chatHistoricoLoaded = chatUserTmp.find(
            (chat) => chat.seqGrupoConversa === Number(seqConversa)
          )?.chatHistorico;

          if (chatHistoricoLoaded !== 'S')
            updateMensageRead(Number(seqConversa));
        }
      } else if (window.location.pathname === '/chat') {
        const seqAtendimento = getParameterByName('id');
        if (Number(seqAtendimento) > 0)
          updateMensageReadAtendimento(Number(seqAtendimento));
      }
    }
  }, [isTabVisible]);

  useEffect(() => {
    hubConnection?.on('ReceiveMessage', (id: number, message: Message[]) => {
      const statusUser = Number(localStorage.getItem('@LiveChat:userStatus'));

      getMensages(id, message);
      const abaAtiva = blnAbaAtiva.current;
      if (abaAtiva) {
        if (window.location.pathname === '/chat') {
          const seqAtendimento = getParameterByName('id');
          if (Number(seqAtendimento) > 0)
            updateMensageReadAtendimento(Number(seqAtendimento));
        }
      }

      if (statusUser === userStatusEnum.Online)
        bntNotification.current?.click();

      const dadosMensagem = message[message.length - 1];

      showNewNotification(
        dadosMensagem.nomeCliente,
        removeTagsHtml(dadosMensagem.texto),
        {
          seqGrupoConversa: 0,
          seqAtendimento: dadosMensagem.seqAtendimento,
        }
      );
    });

    hubConnection?.on('UpdateListClientsWaiting', () => {
      loadClientsWaiting();
      const statusUser = Number(localStorage.getItem('@LiveChat:userStatus'));
      if (statusUser === userStatusEnum.Online)
        bntNotificationNewClient.current?.click();
    });

    hubConnection?.on('SupportFinished', (id: number) => {
      loadDataClient(id);
      divButtonChatRef.current[id].classList.add('bt-flash');
    });

    hubConnection?.on(
      'NewTransfer',
      (seqAtendimento: number, mensagemTransferencia: string) => {
        const statusUser = Number(localStorage.getItem('@LiveChat:userStatus'));
        if (statusUser === userStatusEnum.Online)
          bntNotificationNewClient.current?.click();

        loadClientsAccepted();

        showNewNotification(
          'Transferência de atendimento',
          mensagemTransferencia,
          {
            seqAtendimento,
            seqGrupoConversa: 0,
          }
        );
      }
    );

    hubConnection?.on('MessageRequestService', (data: DataClientService[]) => {
      SetClientMessageService(data);
    });

    hubConnection?.on('UpdateUserStatus', (data: Users) => {
      updateUserStatus(data);
    });

    hubConnection?.on('MessageRead', (seqGrupoConversa: number) => {
      const chatUserString = localStorage.getItem('@LiveChat:chatUser');
      if (chatUserString) {
        const chatUserTemp2: DataChatUser[] = JSON.parse(chatUserString);

        const chatTmp = chatUserTemp2.map((item) => {
          if (item.seqGrupoConversa === seqGrupoConversa) {
            return { ...item, qtdeMensagemNaoLida: 0 };
          }
          return item;
        });
        localStorage.setItem('@LiveChat:chatUser', JSON.stringify(chatTmp));
        setChatUserTmp(chatTmp);
      }
    });

    hubConnection?.on('MessageReadAtendimento', (seqAtendimento: number) => {
      getMensages(seqAtendimento, []);
    });

    hubConnection?.on(
      'ReceiveMessageGroup',
      (seqGrupoConversa: number, data: any, qtdeMensagemNaoLida: number) => {
        const chatUserString = localStorage.getItem('@LiveChat:chatUser');
        if (chatUserString) {
          const chatUserTemp: DataChatUser[] = JSON.parse(chatUserString);

          const existGroup = chatUserTemp.find((item) => {
            return item.seqGrupoConversa === seqGrupoConversa;
          });

          if (existGroup === undefined && seqGrupoConversa > 0) {
            getChatGroup(seqGrupoConversa);
          } else {
            const chatTmp = chatUserTemp.map((item) => {
              if (item.seqGrupoConversa === seqGrupoConversa) {
                return { ...item, qtdeMensagemNaoLida };
              }
              return item;
            });

            localStorage.setItem('@LiveChat:chatUser', JSON.stringify(chatTmp));
            setChatUserTmp(chatTmp);
          }
        }

        getMensagesGroup(seqGrupoConversa, data, 'N');

        const dadosMensagem = data[data.length - 1];
        showNewNotification(
          dadosMensagem.nomeUsuario,
          removeTagsHtml(dadosMensagem.texto),
          {
            seqGrupoConversa:
              dadosMensagem.seqGrupoConversa === undefined
                ? 0
                : dadosMensagem.seqGrupoConversa,
            seqAtendimento:
              dadosMensagem.seqAtendimento === undefined
                ? 0
                : dadosMensagem.seqAtendimento,
          }
        );

        let button = null;
        try {
          button = divButtonChatGroupRef.current[seqGrupoConversa];
        } catch {
          button = null;
        }
        const abaVisible = document.visibilityState === 'visible';

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        const idChat = Number(id);

        if (!abaVisible || Number(idChat) !== seqGrupoConversa) {
          if (button !== null && button !== undefined)
            button.classList.add('bt-flash');
        }

        const abaAtiva = blnAbaAtiva.current;

        if (abaAtiva) {
          if (window.location.pathname === '/chatUser') {
            const seqConversa = getParameterByName('id');
            if (Number(seqConversa) > 0) updateMensageRead(Number(seqConversa));
          }
        }

        const statusUser = Number(localStorage.getItem('@LiveChat:userStatus'));
        if (statusUser === userStatusEnum.Online) {
          bntNotification.current?.click();
        }
      }
    );

    if (hubConnection === undefined) {
      const interval = setInterval(async () => {
        const hubConn = await connectSignalR();
        const userStatus = localStorage.getItem('@LiveChat:userStatus');
        const token = localStorage.getItem('@LiveChat:token');

        registerUserStatus(
          String(token),
          String(hubConn?.connectionId),
          Number(userStatus)
        );
      }, 10000);
      setIntervalID(interval);
    } else {
      clearInterval(intervalID);
    }
  }, [hubConnection]);

  const countMsgNaoLidaAtendimento = (messagesArray: Messages[]): number => {
    return messagesArray.reduce((totalCount, msgs) => {
      return (
        totalCount +
        msgs.messages.reduce((count, message) => {
          return message.seqUsuario === null &&
            message.mensagemLidaUsuario === 'N'
            ? count + 1
            : count;
        }, 0)
      );
    }, 0);
  };

  useEffect(() => {
    const qtdeMsgNaoLidaGrupo = chatUserTmp.reduce((acc, item) => {
      return acc + (item.qtdeMensagemNaoLida ?? 0);
    }, 0);

    const qtdeMsgNaoLidaAtendimento = countMsgNaoLidaAtendimento(messages);
    const qtdeNotification = qtdeMsgNaoLidaGrupo + qtdeMsgNaoLidaAtendimento;

    if (qtdeNotification === 0) {
      badge.clearBadge();
    } else {
      badge.setBadge(qtdeNotification);
    }
  }, [chatUserTmp, messages]);

  useEffect(() => {
    clientsAccepted.forEach((client) => {
      getMensages(client.seqAtendimento, []);
    });
  }, [clientsAccepted]);

  return (
    <div className="d-flex" style={{ width: 'max-content' }}>
      <Button
        className="d-none"
        ref={bntNotification}
        onClick={() => playSoundNotification()}
      />
      <Button
        className="d-none"
        ref={bntNotificationNewClient}
        onClick={() => playSoundNotificationNewClient()}
      />
      {clientsAccepted.map((client) => (
        <div
          key={client.seqAtendimento}
          className={`border-1 me-2 d-flex align-items-center ${
            getUnreadMessagesCount(client.seqAtendimento) > 0 ? 'bt-flash' : ''
          }`}
          style={{
            backgroundColor: '#616161',
            borderRadius: '0.6875rem',
          }}
          ref={(ref: HTMLDivElement) => {
            divButtonChatRef.current[client.seqAtendimento] = ref;
          }}
        >
          <Image
            src={iconConversaCliente}
            className="ms-2"
            style={{ maxHeight: '1.3rem', maxWidth: '1.56rem' }}
          />
          <Button
            className="bg-transparent border-0 shadow-none"
            onClick={() => buttonChat(client.seqAtendimento)}
          >
            <span className="fw-bold" style={{ fontSize: '1.3rem' }}>
              {client?.nomeCliente}
            </span>
          </Button>
          <Button
            className="p-0 bg-transparent border-0 me-2 shadow-none"
            onClick={() => clickButtonMensage(client.seqAtendimento)}
          >
            <BsX style={{ height: '2.12rem', width: '2.12rem' }} />
          </Button>
        </div>
      ))}
      {chatUserTmp
        .sort((a, b) => a.seqGrupoConversa - b.seqGrupoConversa)
        .map((chat: any) => (
          <div
            key={chat.seqGrupoConversa}
            className={`border-1 me-2 d-flex align-items-center ${
              chat.qtdeMensagemNaoLida > 0 ? 'bt-flash' : ''
            }`}
            style={{
              backgroundColor: '#616161',
              borderRadius: '0.6875rem',
            }}
            ref={(ref: HTMLDivElement) => {
              divButtonChatGroupRef.current[chat.seqGrupoConversa] = ref;
            }}
          >
            {chat.seqGrupo > 0 ? (
              <Image
                src={iconConversaGrupo}
                className="ms-2"
                style={{ maxHeight: '1.3rem', maxWidth: '1.56rem' }}
              />
            ) : (
              <UserAcronym
                name={chat.nomeGrupo}
                color={chat.cor === '' ? '#EF8F00' : chat.cor}
                style={{ maxHeight: '1.3rem', maxWidth: '1.56rem' }}
              />
            )}
            <Button
              className="bg-transparent border-0 shadow-none"
              onClick={() => buttonChatUser(chat.seqGrupoConversa)}
            >
              <span className="fw-bold" style={{ fontSize: '1.3rem' }}>
                {chat.nomeGrupo}
              </span>
            </Button>
            <Button
              className="p-0 bg-transparent border-0 me-2 shadow-none"
              onClick={() => clickButtonMensageUsuario(chat.seqGrupoConversa)}
            >
              <BsX style={{ height: '2.12rem', width: '2.12rem' }} />
            </Button>
          </div>
        ))}
    </div>
  );
};

export default FooterMenu;
